import {styled} from "@mui/material/styles"
import {Button, InputBase} from "@mui/material"
import {breakpoints} from "@next/ux-fabric"
import {Form} from "../../component"

export const ClubForm = styled(Form)`
    border-radius: inherit;
    @media (min-width: ${breakpoints.values.md}px) {
        width: 12.5rem;
    }

    @media (min-width: ${breakpoints.values.lg}px) {
        width: 15rem;
    }

    @media (min-width: ${breakpoints.values.xl}px) {
        width: 16.25rem;
    }
`

export const InputContainer = styled(InputBase)`
    width: 100%;
    letter-spacing: normal;

    input:disabled {
        background-color: #f7f7f7;
        border-radius: ${props => props.theme.uxfabric.shape.global.textField.medium.borderRadius};
    }
    input {
        padding: 0rem 2.5rem 0rem 1rem;
        color: ${({theme}) => theme.uxfabric.text.primary};

        font-size: ${({theme}) => theme.uxfabric.component.inputText.fontSize};
        border: none !important;
        /* !important is used to override MVC's !important. Please refrain from using !important.  */
        box-sizing: content-box !important;

        &::-ms-clear {
            display: none;
        }

        ::placeholder {
            color: ${({theme}) => theme.uxfabric.text.secondary};
            opacity: inherit;
            text-transform: ${({theme}) => theme.uxfabric.component.inputText.textTransform};
        }

        // This needs to remain to prevent IOS autozoom when an input box has a font size lower than 16px / 1rem
        @media (max-width: ${breakpoints.values.md - 1}px) {
            font-size: 1rem;
        }
    }
`

export const SubmitButton = styled(Button)`
    && {
        width: 2.75rem;
        min-width: 2.75rem;
        height: 2.75rem;
        min-height: 2.75rem;

        background: ${({theme}) => theme.uxfabric.action.strong.enabled.backgroundColor};
        border: inherit;
        border-radius: inherit;
        transition: none;

        @media (min-width: ${breakpoints.values.md}px) {
            width: 2.25rem;
            min-width: 2.25rem;
            height: 2.25rem;
            min-height: 2.25rem;
        }

        &:hover,
        &:active {
            background: ${({theme}) => theme.uxfabric.action.strong.hovered.backgroundColor};
            border: 0;
        }
    }
`

export const ClearButton = styled("a")`
    width: 2.75rem;
    min-width: 2.75rem;
    height: 2.75rem;
    min-height: 2.75rem;
    right: 2.75rem;

    position: absolute;
    color: ${({theme}) => theme.uxfabric.text.primary};
    margin: 0;
    display: flex;
    justify-content: center;
    align-items: center;

    @media (min-width: ${breakpoints.values.md}px) {
        padding: 0.4375rem 0.5rem;
        width: 2.25rem;
        min-width: 2.25rem;
        height: 2.25rem;
        min-height: 2.25rem;
        right: 2.25rem;
    }
`
